import { buildInstanceWanda, channelsInstance } from '@/api/instances'
import { STAFF_STATUS } from '@/models/channels'
import DatabaseFactory from '@/wrappers/database'
import { addErrorLog } from '@/wrappers/database/utils/addLog'

const fetchChannelById = async (store, { channelId, snapshot }) => {
  const database = new DatabaseFactory(
    `channels/${channelId}`
  ).getReadDatabase()
  if (snapshot) {
    const listener = await database.getOneStream(
      doc => {
        store.commit('setChannel', doc)
      },
      error =>
        addErrorLog({
          context: 'channel/actions - fetchChannelById - listener',
          error
        })
    )

    return listener
  }
  try {
    const channel = await database.getOne()
    const channelData = channel?.data()
    if (!channelData) {
      store.dispatch(
        'errors/setError',
        {
          message: 'Canal não encontrado'
        },
        { root: true }
      )
    }
    return channelData
  } catch (error) {
    if (error.code === 'permission-denied') {
      store.dispatch(
        'errors/setError',
        {
          message: 'Você não tem permissão para buscar canais'
        },
        { root: true }
      )
    }
    addErrorLog({
      context: 'channel/actions - fetchChannelById - get',
      error
    })
  }
}

const fetchTags = async store => {
  try {
    if (store.state.tags?.length) {
      return
    }
    const tags = await channelsInstance.get('channels/tags')
    store.commit('setTags', tags)
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'channel/fetchTags' },
      { root: true }
    )
  }
}

const executeAutomaticFollowUps = store => {
  try {
    const instanceWanda = buildInstanceWanda()
    instanceWanda.post(`automatic_follow_ups/execute`)
    return true
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'channel/executeAutomaticFollowUps',
        message: 'Não foi possível executar o job, tente novamente mais tarde'
      },
      { root: true }
    )
  }
}

/**
 * Check staff status when update
 * AVAILABLE/BUSY - if dont have new chats initialized, get new chats
 * UNAVAILABLE/dont have permission - clear new chats and listener
 * @param {Object} store
 * @returns
 */
const getChatsInformation = (store, loggedStaff) => {
  const ruleStaffUnavailable = loggedStaff?.status === STAFF_STATUS.UNAVAILABLE
  const hasPermissionToGetChat =
    store.rootGetters['user/hasPermissionToGetChat']

  if (ruleStaffUnavailable || !hasPermissionToGetChat) {
    store.dispatch('drawer/clearChatsDrawer', null) //Clear all new chats, on call chats and listeners
    return
  }

  //If status is AVAILABLE or BUSY and dont have chats/oncall listeners active get new listeners
  store.dispatch('drawer/fetchChats')
}

const clearChannelScope = store => {
  store.commit('staff/clearLoggedStaffListener')
  store.dispatch('drawer/clearChatsDrawer')
}

const assignToN2Staff = async (store, { channelId }) => {
  try {
    await channelsInstance.put(`channels/${channelId}/assign_to_n2_staff`)
    return true
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'channel/assign_to_n2_staff',
        message:
          'Ocorreu um problema ao atribuir o canal ao staff, tente novamente.'
      },
      { root: true }
    )
  }
}

export default {
  fetchChannelById,
  fetchTags,
  executeAutomaticFollowUps,
  clearChannelScope,
  getChatsInformation,
  assignToN2Staff
}
